import { render, staticRenderFns } from "./cardother.vue?vue&type=template&id=1072bc5c&scoped=true&"
import script from "./cardother.vue?vue&type=script&lang=js&"
export * from "./cardother.vue?vue&type=script&lang=js&"
import style0 from "./cardother.vue?vue&type=style&index=0&id=1072bc5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1072bc5c",
  null
  
)

export default component.exports